import { css, styled } from "goober";

export const Container = () => css`
  &:has(.showing-more) .card-footer-button svg {
    rotate: 0.5turn;
  }
`;

export const List = styled("div")`
  list-style: none;
  padding-block-end: var(--sp-2);

  .contents {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--sp-2) var(--sp-6);
    transition: background var(--transition);

    &:hover {
      background: var(--shade3-15);
    }

    :where(img) {
      border-radius: var(--br);
    }
  }

  .left {
    display: flex;
    align-items: center;
    gap: var(--sp-3);
  }
  .right {
    text-align: right;
  }
`;
